<template>
  <div class="portfolio">
    <!-- App Title  -->
    <AppTitle></AppTitle>

    <div class="content-title">
      <h2>PORTFOLIO</h2>
      <img src="../assets/images/logotitle (2).png" alt="타이틀이미지">
    </div>

    <!-- portfolio Area Start -->
    <div class="container">

      <div class="gallery-wrap">
        <!-- g-menu -->
        <div class="g-menu">
          <ul>
            <li><a href="#" id="m1">All</a></li>
            <li><a href="#" id="m2">GRAPHIC</a></li>
            <li><a href="#" id="m3">WEB</a></li>
            <li><a href="#" id="m4">RWD</a></li>
            <li><a href="#" id="m5">WEBAPP</a></li>
          </ul>
        </div>

        <!-- gallery -->
        <div class="grid" id="gallery">
          <ul>
            <li class="grid-item g2">
              <a href="#popup1">
                <p>Retina WebSite<br><i class='fa fa-file-photo-o fa-2x' aria-hidden='true'></i></p>
              </a>
              <img src="../assets/images/photoplio/sit11.png" alt="Photo1">
            </li>

            <li class="grid-item g2">
              <a href="#popup2">
                <p>SamSung WebSite<br><i class='fa fa-file-photo-o fa-2x' aria-hidden='true'></i></p>
              </a>
              <img src="../assets/images/photoplio/sit21.png" alt="Photo2">
            </li>

            <li class="grid-item g2">
              <a href="#popup3">
                <p>HyunDai WebSite<br><i class='fa fa-file-photo-o fa-2x' aria-hidden='true'></i></p>
              </a>
              <img src="../assets/images/photoplio/sit31.png" alt="Photo3">
            </li>

            <li class="grid-item g4">
              <a href="#popup4">
                <p>MegaBox HomePage<br><i class='fa fa-file-photo-o fa-2x' aria-hidden='true'></i></p>
              </a>
              <img src="../assets/images/photoplio/app1.png" alt="Photo4">
            </li>

            <li class="grid-item g4">
              <a href="#popup5">
                <p>About Me App<br><i class='fa fa-file-photo-o fa-2x' aria-hidden='true'></i></p>
              </a>
              <img src="../assets/images/photoplio/app21.png" alt="Photo5">
            </li>

            <li class="grid-item g4">
              <a href="#popup6">
                <p>About App<br><i class='fa fa-file-photo-o fa-2x' aria-hidden='true'></i></p>
              </a><img src="../assets/images/photoplio/app31.png" alt="Photo6">
            </li>

            <li class="grid-item g1">
              <a href="#popup7">
                <p>Synthesis Effect<br><i class='fa fa-search-plus fa-2x' aria-hidden='true'></i></p>
              </a>
              <img src="../assets/images/photoplio/grr1.jpg" alt="Photo1">
            </li>

            <li class="grid-item g1">
              <a href="#popup8">
                <p>Prop Layout<br><i class='fa fa-search-plus fa-2x' aria-hidden='true'></i></p>
              </a>
              <img src="../assets/images/photoplio/grr2.jpg" alt="Photo2">
            </li>

            <li class="grid-item g1">
              <a href="#popup9">
                <p>Wavelength Effect<br><i class='fa fa-search-plus fa-2x' aria-hidden='true'></i></p>
              </a>
              <img src="../assets/images/photoplio/grr3.jpg" alt="Photo3">
            </li>

            <li class="grid-item g3">
              <a href="#popup10">
                <p>Rolls-Royce<br><i class='fa fa-search-plus fa-2x' aria-hidden='true'></i></p>
              </a>
              <img src="../assets/images/photoplio/web12.png" alt="Photo4">
            </li>

            <li class="grid-item g3">
              <a href="#popup11">
                <p>Aeyong Word<br><i class='fa fa-search-plus fa-2x' aria-hidden='true'></i></p>
              </a>
              <img src="../assets/images/photoplio/web21.png" alt="Photo5">
            </li>

            <li class="grid-item g3">
              <a href="#popup12">
                <p>Web Stone<br><i class='fa fa-search-plus fa-2x' aria-hidden='true'></i></p>
              </a>
              <img src="../assets/images/photoplio/web31.png" alt="Photo6">
            </li>

          </ul>
        </div>
      </div>

      <!-- Popup Content 1 -->
      <div id="popup1" class="white-popup mfp-hide">
        <div class="text_box">
          <h2>RETINA WED AGENCY</h2>
          <div class="icon-1"><i class='fa fa-remove fa-2x' aria-hidden='true'></i></div>
          <ul>
            <li>WEB</li>
            <li>HTML5</li>
            <li>CSS3</li>
            <li>JQUERY</li>
            <li>Javascript</li>
          </ul>
          <h4>퍼블리싱 100% <br> 제작기간 4일</h4>

          <p>포토샵,XD를 사용해 1200그리드의 <br>
            시안과 목업을 제작하고 HTML5,CSS3,JQUERY, Javascript로 <br>
            웹페이지를 제작하였습니다. 우측 글시를 클릭하시면 사이트를 확인하실수있습니다.
          </p>

          <p class="rig">
            <a href="http://young99.dothome.co.kr/WEB/Retina/" target="blank">
              <i class='fa fa-mail-forward' aria-hidden='true'></i>
              Go Site
            </a>
          </p>
        </div>
        <div class="img"><img src="../assets/images/photoplio/sit1.png" alt="Photo1"></div>
      </div>
      <!-- Popup Content 2 -->
      <div id="popup2" class="white-popup mfp-hide">
        <div class="text_box">
          <h2>SamSung WebSite</h2>
          <div class="icon-1"><i class='fa fa-remove fa-2x' aria-hidden='true'></i></div>
          <ul>
            <li>WEB</li>
            <li>HTML5</li>
            <li>CSS3</li>
            <li>Javascript</li>
          </ul>
          <h4>퍼블리싱 100% <br> 제작기간 3일</h4>

          <p>포토샵,XD를 사용해 1200그리드의 <br>
            시안과 목업을 제작하고 HTML5,CSS3,Javascript로 <br>
            웹페이지를 제작하였습니다. 우측 글시를 클릭하시면 사이트를 확인하실수있습니다.
          </p>

          <p class="rig">
            <a href="http://young99.dothome.co.kr/WEB/samsung/" target="blank">
              <i class='fa fa-mail-forward' aria-hidden='true'></i>
              Go Site
            </a>
          </p>
        </div>
        <div class="img"><img src="../assets/images/photoplio/sit2.png" alt="Photo2"></div>
      </div>

      <!-- Popup Content 3 -->
      <div id="popup3" class="white-popup mfp-hide">
        <div class="text_box">
          <h2>HyunDai WebSite</h2>
          <div class="icon-1"><i class='fa fa-remove fa-2x' aria-hidden='true'></i></div>
          <ul>
            <li>WEB</li>
            <li>HTML5</li>
            <li>CSS3</li>
          </ul>
          <h4>퍼블리싱 100% <br> 제작기간 3일</h4>

          <p>포토샵,XD를 사용해 1200그리드의 <br>
            시안과 목업을 제작하고 HTML5,CSS3 로 <br>
            웹페이지를 제작하였습니다. 우측 글시를 클릭하시면 사이트를 확인하실수있습니다.
          </p>

          <p class="rig">
            <a href="http://young99.dothome.co.kr/WEB/hyundai/" target="blank">
              <i class='fa fa-mail-forward' aria-hidden='true'></i>
              Go Site
            </a>
          </p>
        </div>
        <div class="img"><img src="../assets/images/photoplio/sit3.png" alt="Photo3"></div>
      </div>

      <!-- Popup Content 4 -->
      <div id="popup4" class="white-popup mfp-hide">
        <div class="text_box">
          <h2>MegaBox HomePage</h2>
          <div class="icon-1"><i class='fa fa-remove fa-2x' aria-hidden='true'></i></div>
          <ul>
            <li>WEB App</li>
            <li>SCSS</li>
            <li>HTML5</li>
            <li>JQUERY</li>
            <li>Javascript</li>
            <li>RWD</li>
            <li>Vue.js</li>
          </ul>
          <h4>퍼블리싱 100%
            제작기간 5일</h4>
          <p>포토샵,XD를 사용해 시안과 목업을 제작하고  HTML5,SCSS,Vue.Js,JQUERY, JQUERY플러그인 을 사용하여
            WEB APP 을 구현하고 설치하였습니다. 우측 글시를 클릭하시면 앱을 확인하실수있습니다.</p>

          <p class="rig">
            <a href="https://magaboxtt.netlify.app" target="blank">
              <i class='fa fa-mail-forward' aria-hidden='true'></i>
              Go App
            </a>
          </p>
        </div>
        <div class="img"><img src="../assets/images/photoplio/app1.png" alt="Photo4"></div>
      </div>

      <!-- Popup Content 5 -->
      <div id="popup5" class="white-popup mfp-hide">
        <div class="text_box">
          <h2>About Me App</h2>
          <div class="icon-1"><i class='fa fa-remove fa-2x' aria-hidden='true'></i></div>
          <ul>
            <li>WEB App</li>
            <li>SCSS</li>
            <li>HTML5</li>
            <li>JQUERY</li>
            <li>Javascript</li>
            <li>RWD</li>
            <li>Vue.js</li>
          </ul>
          <h4>퍼블리싱 100%
            제작기간 5일</h4>
          <p>포토샵,XD를 사용해 시안과 목업을 제작하고  HTML5,SCSS,Vue.Js,JQUERY, JQUERY플러그인 을 사용하여
            WEB APP 을 구현하고 설치하였습니다. 우측 글시를 클릭하시면 앱을 확인하실수있습니다.</p>
          <p class="rig">
            <a href="https://aboutahyoung.netlify.app" target="blank">
              <i class='fa fa-mail-forward' aria-hidden='true'></i>
              Go App</a>
          </p>
        </div>
        <div class="img"><img src="../assets/images/photoplio/app2.png" alt="Photo6"></div>
      </div>

      <!-- Popup Content 6 -->
      <div id="popup6" class="white-popup mfp-hide">
        <div class="text_box">
          <h2>About App</h2>
          <div class="icon-1"><i class='fa fa-remove fa-2x' aria-hidden='true'></i></div>
          <ul>
            <li>WEB App</li>
            <li>SCSS</li>
            <li>HTML5</li>
            <li>JQUERY</li>
            <li>Javascript</li>
            <li>RWD</li>
            <li>Vue.js</li>
          </ul>
          <h4>퍼블리싱 100%
            제작기간 5일</h4>
          <p>포토샵,XD를 사용해 시안과 목업을 제작하고  HTML5,SCSS,Vue.Js,JQUERY, JQUERY플러그인 을 사용하여
            WEB APP 을 구현하고 설치하였습니다. 우측 글시를 클릭하시면 앱을 확인하실수있습니다.</p>

          <p class="rig">
            <a href="https://about-app.netlify.app/" target="blank">
              <i class='fa fa-mail-forward' aria-hidden='true'></i>
              Go App
            </a>
          </p>
        </div>
        <div class="img"><img src="../assets/images/photoplio/app3.png" alt="Photo6"></div>
      </div>
      <!-- Popup Content 7 -->
      <div id="popup7" class="white-popup mfp-hide img_box">
        <div class="img1"><img src="../assets/images/photoplio/grr1.jpg" alt="Photo6"></div>
        <h2>Synthesis Effect</h2>
      </div>
      <!-- Popup Content 8 -->
      <div id="popup8" class="white-popup mfp-hide img_box">
        <div class="img1"><img src="../assets/images/photoplio/grr2.jpg" alt="Photo6"></div>
        <h2>Prop Layout</h2>
      </div>
      <!-- Popup Content 9 -->
      <div id="popup9" class="white-popup mfp-hide img_box">
        <div class="img1"><img src="../assets/images/photoplio/grr3.jpg" alt="Photo6"></div>
        <h2>Wavelength Effect</h2>
      </div>
      <!-- Popup Content 10 -->
      <div id="popup10" class="white-popup mfp-hide">
        <div class="text_box">
          <h2>Rolls-Royce</h2>
          <div class="icon-1"><i class='fa fa-remove fa-2x' aria-hidden='true'></i></div>
          <ul>
            <li>RWD</li>
            <li>HTML5</li>
            <li>SCSS</li>
            <li>JQUERY</li>
            <li>Javascript</li>
            <li>BOOT STRAP</li>
          </ul>
          <h4>제작기간 5일</h4>
          <p>
            HTML5,CSS3,JQUERY,Boot strap 으로
            반응형 사이트를 구현하였습니다. 우측 글시를 클릭하시면 사이트를 확인하실수있습니다.</p>
          <p class="rig">
            <a href="http://young99.dothome.co.kr/RWD/rolls-royce/" target="blank">
              <i class='fa fa-mail-forward' aria-hidden='true'></i>
              Go Sit</a>
          </p>
        </div>
        <div class="img"><img src="../assets/images/photoplio/web1.png" alt="Photo6"></div>
      </div>

         
      <!-- Popup Content 11 -->
      <div id="popup11" class="white-popup mfp-hide">
        <div class="text_box">
          <h2>AeYong Word</h2>
          <div class="icon-1"><i class='fa fa-remove fa-2x' aria-hidden='true'></i></div>
          <ul>
            <li>RWD</li>
            <li>HTML5</li>
            <li>SCSS</li>
            <li>JQUERY</li>
            <li>Javascript</li>
            <li>BOOT STRAP</li>
          </ul>
          <h4> 제작기간 3일</h4>
          <p>
            HTML5,SCSS,JQUERY, Boot strap 으로
            반응형 사이트 를 구현하였습니다.  우측 글시를 클릭하시면 사이트를 확인하실수있습니다.</p>
          <p class="rig">
            <a href="http://young99.dothome.co.kr/RWD/aeyong-word/" target="blank">
              <i class='fa fa-mail-forward' aria-hidden='true'></i>
              Go Sit</a>
          </p>
        </div>
        <div class="img"><img src="../assets/images/photoplio/web2.png" alt="Photo6"></div>
      </div>

      <!-- Popup Content 12 -->
      <div id="popup12" class="white-popup mfp-hide">
        <div class="text_box">
          <h2>Wed Stone</h2>
          <div class="icon-1"><i class='fa fa-remove fa-2x' aria-hidden='true'></i></div>
          <ul>
            <li>RWD</li>
            <li>HTML5</li>
            <li>SCSS</li>
            <li>JQUERY</li>
            <li>Javascript</li>
            <li>BOOT STRAP</li>
          </ul>
          <h4>퍼블리싱 100%<br> 제작기간 5일</h4>
          <p>포토샵,XD를 사용해 시안과 목업을 제작하고</p>
          <p>HTML5,SCSS,JQUERY,Bootstrap 으로
            반응형 사이트 를 구현하였습니다.  우측 글시를 클릭하시면 사이트를 확인하실수있습니다.</p>
          <p class="rig">
            <a href="http://young99.dothome.co.kr/RWD/webstone/" target="blank">
              <i class='fa fa-mail-forward' aria-hidden='true'></i>
              Go Sit</a>
          </p>
        </div>
        <div class="img"><img src="../assets/images/photoplio/web3.png" alt="Photo6"></div>
      </div>


    </div>
  </div>
</template>

<script>
import AppTitle from './component/Header.vue';
export default {
  name: "Portfolio",
  components: {
    AppTitle
  },
  mounted() {
    this.gg();
    this.menuAct3();
  },
  methods: {
    gg() {
      var imgItem = $(".grid");
      // 팝업창 처리함수
      var grid = $('.grid');
      $('.grid').isotope({
        // options
        itemSelector: '.grid-item',
        layoutMode: 'fitRows'
      });

      // 매그니픽 팝업 초기설정
      $('.grid-item a').magnificPopup({
        type: 'inline',
        closeBtnInside: false,   // 클로즈('X') 버튼 보이기
        closeOnBgClick: true,   // 배경클릭 창닫기 기능해제 
        gallery: {
          enabled: true
        }
      });

      $('.icon-1').click(function () {
        $.magnificPopup.close();   // 창닫기 코드
      });


      // 필터링 버튼설정
      var m1 = $('#m1');
      var m2 = $('#m2');
      var m3 = $('#m3');
      var m4 = $('#m4');
      var m5 = $('#m5');
      var mall = $(".g-menu ul li a");
      let num = 0;

      m1.css('color', '#548DF8');

      m1.click(function (e) {

        mall.css('color', '#000'), m1.css('color', '#548DF8');

        // 1. 정열기능
        grid.isotope({ filter: '.grid-item' });

        // 2. 라이트박스 기능
        $('.grid-item a').magnificPopup({
          type: 'inline',
          midClick: true,
          closeBtnInside: false,
          closeOnBgClick: true,
          gallery: {
            enabled: true
          }
        });

        e.preventDefault();

      });

      m2.click(function (e) {

        mall.css('color', '#000'), m2.css('color', '#548DF8');


        grid.isotope({ filter: '.g1' });


        $('.g1 a').magnificPopup({
          type: 'inline',
          closeBtnInside: false,
          closeOnBgClick: true,
          gallery: {
            enabled: true
          }
        });

        e.preventDefault();

      });

      m3.click(function (e) {

        mall.css('color', '#000'), m3.css('color', '#548DF8');


        grid.isotope({ filter: '.g2' });


        $('.g2 a').magnificPopup({
          type: 'inline',
          closeBtnInside: false,
          closeOnBgClick: true,
          gallery: {
            enabled: true
          }
        });

        e.preventDefault();
      });

      m4.on('click', function (e) {

        mall.css('color', '#000'), m4.css('color', '#548DF8');

        grid.isotope({ filter: '.g3' });

        $('.g2 a').magnificPopup({
          type: 'inline',
          closeBtnInside: false,
          closeOnBgClick: true,
          gallery: {
            enabled: true
          }
        });

        e.preventDefault();

      });

      m5.click(function (e) {

        mall.css('color', '#000'), m5.css('color', '#548DF8');

        grid.isotope({ filter: '.g4' });

        $('.g2 a').magnificPopup({
          type: 'inline',
          closeBtnInside: false,
          closeOnBgClick: true,
          gallery: {
            enabled: true
          }
        });

        e.preventDefault();

      });
    },
    menuAct3() {
      $('.Portfolio').removeClass('menu-act');
      $('.Portfolio').addClass('menu-act');
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../sass/partials/_mixin.scss", "../sass/partials/_variable.scss";

.portfolio {
  .container {
    width: 350px;
    height: 1500px;
    margin: 30px auto;

    .gallery-wrap {
      .g-menu {
        width: 100%;
        height: 40px;
        margin-bottom: 40px;
        text-align: center;

        li {
          display: inline-block;
          height: 100%;

          a {
            display: block;
            height: 100%;
            padding: 5px;
            font: bold 15px/17px 'Ubuntu', sans-serif;
            color: #000;
            text-decoration: none;

            &:hover {
              background-color: none;
              color: $m-bg1
            }
          }
        }
      }

      #gallery {
        &::after {
          @include clear;
        }

        li {
          display: inline-block;
          width: 150px;
          height: 150px;
          margin: 20px 10px 10px;
          position: relative;

          &:hover p {
            opacity: 1;
          }
          &:hover img {
            border: 5px solid $m-bg1;
            
          }

          a {
            z-index: 999;
          }

          img {
            width: 100%;
            height: 100%;
            cursor: pointer;
            border: 3px solid $m-bg1;
            border-radius: 50%;
          
          }

          p {
            /* 마우스 hover 했을때 나타는 효과 */
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.5);
            border-radius: 50%;
            position: absolute;
            cursor: pointer;
            text-align: center;
            color: #fff;
            padding-top: 40px;
            @include font-set(bold, 13px, 40px, $ff6);
            opacity: 0;
            @include trs(0.5s);

            i {
              padding-top: 5px;
            }

            &:hover::after {
              content: '';
              display: block;
              width: 78px;
              height: 78px;
              border-radius: 50%;
              border: 1px solid $m-bg1;
              position: absolute;
              top: 35px;
              left: 35px;

              -webkit-transform: scale(2);
              -moz-transform: scale(2);
              -o-transform: scale(2);
              transform: scale(2);
            }
          }
        }
      }
    }
  }
}

.icon-1 {
  position: absolute;
  top: 8px;
  right: 10px;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/portfolio.vue